import { render, staticRenderFns } from "./public-summons-answer.vue?vue&type=template&id=aae4aae2&scoped=true&"
import script from "./public-summons-answer.vue?vue&type=script&lang=ts&"
export * from "./public-summons-answer.vue?vue&type=script&lang=ts&"
import style0 from "./public-summons-answer.vue?vue&type=style&index=0&id=aae4aae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae4aae2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
